import React, { FunctionComponent } from 'react';
import { Checkbox, Fieldset, Layout } from '@vwfs-bronson/bronson-react';
import { t } from 'i18next';
import { useFormikContext } from 'formik';
import { NoYesEnum } from '../../../types/forms';

export interface ConsentFormModel {
  storeQuoteTwelveMonths?: NoYesEnum;
  isBusinessTypeUnselected?: boolean;
}

export const StoreQuoteTwelveMonthsConsent: FunctionComponent<ConsentFormModel> = ({ isBusinessTypeUnselected }) => {
  const { values, setFieldValue } = useFormikContext<ConsentFormModel>();

  return (
    <Fieldset.Row className="u-ml-xsmall">
      <Layout>
        <Layout.Item default="1/12" l="1/6" m="1/4" s="1/2">
          <Checkbox
            checked={values.storeQuoteTwelveMonths === NoYesEnum.yes}
            onChange={(e) => {
              const { checked } = e.target;
              const newValue = checked ? NoYesEnum.yes : undefined;
              setFieldValue('storeQuoteTwelveMonths', newValue, true);
            }}
            disabled={isBusinessTypeUnselected}
          >
            {t('prospectPage:consent:yes')}
          </Checkbox>
        </Layout.Item>

        <Layout.Item default="1/12" l="1/6" m="1/4" s="1/2">
          <Checkbox
            checked={values.storeQuoteTwelveMonths === NoYesEnum.no}
            onChange={(e) => {
              const { checked } = e.target;
              const newValue = checked ? NoYesEnum.no : undefined;
              setFieldValue('storeQuoteTwelveMonths', newValue, true);
            }}
            disabled={isBusinessTypeUnselected}
          >
            {t('prospectPage:consent:no')}
          </Checkbox>
        </Layout.Item>
      </Layout>
    </Fieldset.Row>
  );
};
